import { appName } from '@/constants'

export default function setPageTitle(title?: string): void {
  window.document.title = 'Sure Winph -Slots Philippines|Comebet.com\nkeywords:Sure Winph,Slots Philippines,Online slots Philippines,Comebet,Comebet.com,Philippines online casino,PH slots site'
}
